import { render, staticRenderFns } from "./Catalog-company.vue?vue&type=template&id=31ca4e28"
import script from "./Catalog-company.vue?vue&type=script&lang=js"
export * from "./Catalog-company.vue?vue&type=script&lang=js"
import style0 from "./Catalog-company.vue?vue&type=style&index=0&id=31ca4e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports